/** @graphql cc **/
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ExcerptIncludeTargetPageByIdQuery: GraphQLTaggedNode = graphql`
	query ExcerptIncludeTargetPageByIdQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				body {
					atlas_doc_format {
						value
					}
				}
			}
		}
	}
`;
